export const isLoadingSelector = state => state.createComment.get('isLoading');
export const isReplyLoadingSelector = state => state.createComment.get('isReplyLoading');
export const formErrorsSelector = state => state.createComment.get('errors');
export const replyFormErrorsSelector = state => state.createComment.get('replyErrors');
